/// <reference types="youtube" />

declare global {
    interface Window {
        YT?: typeof YT & { loaded?: number };
    }
}

const toggleOverlay = (videoPlayerElement: HTMLDivElement, show: boolean) => {
    const videoIframe = videoPlayerElement.querySelector<HTMLIFrameElement>('iframe');
    if (videoIframe) {
        videoIframe.tabIndex = show ? -1 : 0;
    }
    videoPlayerElement
        .querySelector<HTMLDivElement>('.video-player--overlay')
        ?.classList.toggle('video-player--overlay-playing', !show);
};

const checkIfClientSupportsInlineVideo = () => {
    const isIOS =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    return !isIOS && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) >= 768;
};

const createPlayer = (videoPlayerElement: HTMLDivElement, videoElement: HTMLDivElement) => {
    const YT = window.YT;
    if (!YT || YT.loaded !== 1) return;
    const videoId = videoPlayerElement.dataset.videoId;
    const autoPlay = videoPlayerElement.dataset.autoplay === 'true' && checkIfClientSupportsInlineVideo();
    return new YT.Player(videoElement, {
        host: 'https://www.youtube-nocookie.com',
        height: '100%',
        width: '100%',
        videoId,
        playerVars: {
            autoplay: autoPlay ? 1 : 0,
            controls: 1,
            disablekb: 0,
            loop: autoPlay ? 1 : 0,
            playsinline: autoPlay ? 1 : 0,
            rel: 0,
            showinfo: 0,
            playlist: videoId,
        },
        events: {
            onReady: (event) => {
                videoPlayerElement.querySelector('.video-player--play-button')?.addEventListener('click', () => {
                    event.target.playVideo();
                    videoPlayerElement
                        .querySelector('.video-player--overlay')
                        ?.classList.add('video-player--overlay-playing');
                    toggleOverlay(videoPlayerElement, false);
                });
                if (autoPlay) {
                    event.target.mute();
                    event.target.playVideo();
                }
            },
            onStateChange: (event) => {
                if (event.data === YT.PlayerState.ENDED) {
                    // replace video with overlay when video has ended
                    if (!autoPlay) toggleOverlay(videoPlayerElement, true);
                }
                if (event.data === YT.PlayerState.PLAYING) {
                    // removes overlay here to so we won't see built in fade-out of default image
                    toggleOverlay(videoPlayerElement, false);
                }
            },
        },
    });
};

export const setUpVideoPlayer = (videoPlayerElement: HTMLDivElement) => {
    const videoElement = videoPlayerElement.querySelector<HTMLDivElement>('div[data-video]');
    if (!videoElement) return;

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.defer = true;
    if (document.querySelectorAll(`script[src="${tag.src}"]`).length === 0) {
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
    }

    let count = 0;

    function initializePlayer() {
        count++;

        const player = createPlayer(videoPlayerElement, videoElement!);

        if (player) return;
        else {
            if (count > 200) return;
            else setTimeout(initializePlayer, 50);
        }
    }

    initializePlayer();
};
